import React from 'react';
import { useTranslation } from 'react-i18next';
import { differenceInMonths, isSameDay } from 'date-fns';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsTableRow from '../ManageContractsTableRow';
import { Delivery } from '../../../../types/contract';
import { PriceFixTariffNo } from '../../../../utils/contracts';

export const NewContract: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const { selectedForm, selectedForm4, oldContract, campaignOmaLummePrices, newContract, useVaihtoturva } = ManageContractsApp.useState();

  // Disable "Continue with current contract" feature for Ekosähkö contracts 54 and 55
  const selectedContractDeliveries = oldContract?.activeDeliveries?.filter((d) => d.tariffNo !== 54 && d.tariffNo !== 55);

  const spotPriceFixes = oldContract?.deliveries
    ?.sort((a, b) => (new Date(a.specialToDate || new Date()).getTime() < new Date(b.specialToDate || new Date()).getTime() ? -1 : 1))
    .filter(
      (d) =>
        d.tariffNo === PriceFixTariffNo &&
        d.elementNo === 10 &&
        new Date(d.specialToDate || new Date()).getTime() > new Date().getTime() &&
        new Date(d.specialToDate || new Date()).getTime() !== new Date('2073-06-01').getTime(),
    );

  const lastSpotPriceFixEndDate = spotPriceFixes && spotPriceFixes.length > 0 ? spotPriceFixes.at(-1)?.specialToDate : undefined;

  return (
    <section className="manage-contracts-step stepNewContract">
      {selectedForm !== 4 && <h3>{t('manageContracts:manageContracts.SelectNewContractTitle')}*</h3>}
      {selectedForm === 4 && <h3>{t('manageContracts:manageContracts.SelectNewContractTitleForm4')}*</h3>}

      <div className="manage-contracts-table withSpot">
        <header className="manage-contracts-table-header">
          <div>{t('manageContracts:manageContracts.TableContract')}</div>
          <div className="incTax">{t('manageContracts:manageContracts.TableBase')}</div>
          <div className="incTax">{t('manageContracts:manageContracts.TableEnergy')}</div>
          <div className="incTax margin">{t('manageContracts:manageContracts.TableMargin')}</div>
          <div>{t('manageContracts:manageContracts.TablePeriod')}</div>
          <div></div>
        </header>
        {selectedForm !== 4 &&
          selectedContractDeliveries &&
          selectedContractDeliveries.length > 0 &&
          (!isSameDay(new Date(selectedContractDeliveries[0].tariffToDate), new Date('2073-06-01')) || lastSpotPriceFixEndDate) &&
          differenceInMonths(new Date(selectedContractDeliveries[0].tariffToDate), new Date()) >= 3 && (
            <ManageContractsTableRow
              key={0}
              newContract={true}
              contractNo="0-0"
              selected={newContract === `0-0`}
              currentContract={true}
              contractEndDate={lastSpotPriceFixEndDate ?? selectedContractDeliveries[0].tariffToDate}
              contractTitle={selectedContractDeliveries[0].externalName}
              contractName={selectedContractDeliveries[0].externalName}
              basePrice={selectedContractDeliveries.find((d) => d.amountUnit === 'months')?.priceInclVat}
              energyDeliveries={spotPriceFixes ?? selectedContractDeliveries.filter((d) => d.amountUnit === 'kWh')}
              energyPrice={selectedContractDeliveries.find((d) => d.amountUnit === 'kWh')?.priceInclVat}
              contractLength={differenceInMonths(
                new Date(
                  lastSpotPriceFixEndDate && isSameDay(new Date(selectedContractDeliveries[0].tariffToDate), new Date('2073-06-01'))
                    ? '-'
                    : selectedContractDeliveries[0].tariffToDate,
                ),
                new Date(selectedContractDeliveries[0].tariffFromDate),
              )}
              tableHasSpot={true}
              contractDescription={selectedContractDeliveries[0].externalDescription}
            />
          )}

        {campaignOmaLummePrices.length > 0 &&
          campaignOmaLummePrices.map((campaign) => {
            return campaign.tariffs.map((tariff) => {
              const isSpot = tariff.externalName.toLowerCase().includes('pörssi') || tariff.externalName.toLowerCase().includes(' spot');
              const basePrice = tariff.tariffElements.find((element) => element.elementNo === 1)?.priceInclVat;
              const energyPrice = tariff.tariffElements.find((element) => element.elementNo === 2)?.priceInclVat;
              const margin = isSpot ? tariff.tariffElements.find((element) => element.elementName.toLowerCase() === 'marginaali')?.priceInclVat : 0;

              const offer = tariff.tariffElements.find((element) => element.elementNo === 21);

              let filteredDeliveries: Delivery[] = [];
              if (selectedContractDeliveries) {
                filteredDeliveries = selectedContractDeliveries.filter(
                  (d) => !(d.elementName.toLowerCase().includes('vaihtoturva') || d.elementName.toLowerCase().includes('hyvitys')),
                );
              }

              if (filteredDeliveries && filteredDeliveries.length > 0) {
                const currentLength = differenceInMonths(
                  new Date(filteredDeliveries[0].tariffToDate),
                  new Date(filteredDeliveries[0].tariffFromDate),
                );

                if (selectedForm === 4 && selectedForm4 && useVaihtoturva && useVaihtoturva.length > 0 && tariff.duration !== currentLength) {
                  return false;
                }
              }
              return (
                <ManageContractsTableRow
                  key={tariff.tariffNo}
                  newContract={true}
                  contractNo={`${campaign.contractTemplateNo}-${tariff.tariffNo}`}
                  selected={newContract === `${campaign.contractTemplateNo}-${tariff.tariffNo}`}
                  currentContract={false}
                  contractTitle={tariff.externalName}
                  contractName={tariff.externalName}
                  basePrice={basePrice}
                  energyPrice={energyPrice}
                  margin={margin}
                  tableHasSpot={true}
                  contractIsSpot={isSpot}
                  contractLength={tariff.duration}
                  contractDescription={campaign.salesTexts.find((text) => text.id === 2)?.salesText}
                  contractOffer={offer && offer.discountInfo ? true : false}
                  offerDuration={offer && offer.discountInfo ? offer.discountInfo.duration : 0}
                  offerPrice={offer && offer.priceInclVat ? (offer.priceInclVat ?? 0) : 0}
                />
              );
            });
          })}
        <footer className="manage-contracts-table-footer">{t('consumption:consumption:theseIncTax')}</footer>
      </div>
    </section>
  );
};

export default NewContract;
